import { CircularProgress, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import React from 'react';

import styles from '../styles/domainNumberRangeCell';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import Optional from '../../../utils/optional';
import { doesArrayHasLength, isArray } from '../../../utils/isDefined';
import clsx from 'clsx';
import { MAX_NUMBERS_TO_CHECK } from '../actions/fetchLookupOperators';
import { translate } from '../../../i18n/I18nProvider';

function OperatorCell({ data = {}, classes, isLoading, isBeTable }) {
  return (
    <div className={classes.root}>
      <div className={classes.root}>
        {isLoading && !doesArrayHasLength(data.service_operator) && (
          <CircularProgress size={18} />
        )}
        {isArray(data.service_operator) && data.service_operator.length > 3 ? (
          <Tooltip title={data.service_operator.join(', ')}>
            <span>{data.service_operator.slice(0, 3).join(', ')} ...</span>
          </Tooltip>
        ) : (
          Optional(data.service_operator)
            .map(operators => operators.join(', '))
            .or('')
        )}
        {isBeTable && data.interval > MAX_NUMBERS_TO_CHECK && (
          <Tooltip
            title={translate('TOOLTIP.OPERATOR_COLUMN_INFO', {
              count: MAX_NUMBERS_TO_CHECK
            })}
          >
            <i className={clsx('fas fa-info-circle', classes.infoIcon)}></i>
          </Tooltip>
        )}
      </div>
    </div>
  );
}

const mapStatesToProps = ({ loader }) => {
  return {
    isLoading: loader.isSpinVisible
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(OperatorCell);
